<template>
  <div class="item">
      <div class="image">
        <i class="material-icons mdl-list__item-avatar">person</i>
      </div>
      <div class="content">
        <a  class="header" v-bind:href="'//www.youtube.com/channel/' + video.channel_id" target='_blank'>{{ video.channel_title }}</a>
      </div>
      <div class="meta">
        <span>Description</span>
      </div>
      <div class="description">
        <p></p>
      </div>
      <div class="extra">
        <a class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect" v-on:click="show" v-bind:hrxef="'https://youtu.be/' + video.video_id" target='_blank'>{{ video.title }}</a>
      </div>
  </div>
</template>
<script>
  export default {
    name: 'video-list-item',
    props: ['video'],
    data () {
      return {
        page: 1,
        keyword: ''
      }
    },
    methods: {
      show () {
        this.$emit('setVideoItem', this.video)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// VideoListItem.vue?0c5cec46